import styles from "./AmbientBubbles.module.css";

/**
 * Scaled-down welcome bubble field. Parent should be position: relative
 * (and overflow: hidden to clip the blobs).
 *
 * @param {{ className?: string }} props
 */
const AmbientBubbles = ({ className = "" }) => {
  return (
    <div
      className={`${styles.field}${className ? ` ${className}` : ""}`}
      aria-hidden="true"
    >
      <div className={styles.bubble} />
      <div className={styles.bubble} />
      <div className={styles.bubble} />
      <div className={styles.bubble} />
    </div>
  );
};

export default AmbientBubbles;
